import React, { useRef } from "react";
import { useState } from "react";
import { Country, State } from "country-state-city";
import { ToastContainer, toast } from "react-toastify";
import { useEffect } from "react";
import { updateContactSuppport } from "./service";
import { useSelector } from "react-redux";
import Translate from "../../Components/MultiLanguage/Translate";
import { useTranslateText } from "../../Components/MultiLanguage/Translate";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import ReCAPTCHA from "react-google-recaptcha";
import { isValidPhoneNumber, parsePhoneNumber } from 'libphonenumber-js';

const ContactSupportKalingo = () => {
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const accessToken = useSelector((state) => state?.accessToken?.value);

  const urlParams = new URLSearchParams(window.location.search);
  const advertise = urlParams.get("adv");
  const captchaRef = useRef(null);

  const [values, setValues] = useState({});
  const [country, setCountry] = useState();
  const [disableblock, setDisableblock] = useState(false);
  const [errors, setErrors] = useState({});
  const [captchaValue, setCaptchaValue] = useState(null);
  const [processing, setProcessing] = useState(false);
  const translateText = useTranslateText();
  const appInfo = {
    projectDetails: projectInfo,
    accessToken: accessToken,
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    let country = Country.getAllCountries();
    setCountry(country);
  }, []);

  useEffect(() => {
    advertise && setValues({
      ...values,
      ["issues"]: "Advertise with us",
    });
    // Set topic from URL if present
    const urlParams = new URLSearchParams(window.location.search);
    const topicParam = urlParams.get("topic");
    if (topicParam) {
      // Map URL param to dropdown value
      const topicMap = {
        get_your_existing_tv_channel_on_kalingo: "Get your Existing TV Channel on Kalingo",
        submit_your_content: "Submit your Content",
        submit_your_script: "Submit your Script",
        request_film_financing: "Request Film Financing",
        request_collaboration: "Request Collaboration",
        request_to_rent_a_tv_channel: "Request to Rent a TV Channel",
        request_to_rent_tv_airtime: "Request to Rent TV Airtime",
        request_to_stream_an_event_per_ppv: "Request to Stream an Event per PPV",
        get_your_content_videos_on_kalingo_tv: "Get your content / videos on Kalingo TV",
        advertise_with_us: "Advertise With Us",
      };
      const mappedTopic = topicMap[topicParam];
      if (mappedTopic) {
        setValues((prev) => ({ ...prev, issues: mappedTopic }));
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    } else {
      setValues((prev) => ({ ...prev, issues: "Contact Us" }));
    }
  }, [advertise, window.location.search]);

  const formValidation = () => {
    const { country, email, issues, fname, lname, message, platform, topic, phone } = values;
    let validationStatus = true;
    let error = {};
    let emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

    if (!country || country === "") {
      error.country = <Translate textKey={'required'} />;
      validationStatus = false;
    }

    if (!email) {
      error.email = <Translate textKey={'required'} />;
      validationStatus = false;
    } else if (!email?.match(emailRegex)) {
      error.email = <Translate textKey={'valid_email_message'} />;
      validationStatus = false;
    }

    if (!issues) {
      error.issues = <Translate textKey={'required'} />;
      validationStatus = false;
    } else if (issues === "Technical Issue") {
      if (!platform || platform === "Select Platform") {
        error.platform = <Translate textKey={'required'} />;
        validationStatus = false;
      }
      if (!topic || topic === "Select Topic") {
        error.topic = <Translate textKey={'required'} />;
        validationStatus = false;
      }
    }

    if (!fname) {
      error.fname = <Translate textKey={'required'} />;
      validationStatus = false;
    }

    if (!lname) {
      error.lname = <Translate textKey={'required'} />;
      validationStatus = false;
    }
    if (!message) {
      error.message = <Translate textKey={'required'} />;
      validationStatus = false;
    } else if (message?.length < 5) {
      error.message = <Translate textKey={'minimum_character_required'} />;
      validationStatus = false;
    }

    try {
      if (!phone || phone.trim() === "") {
        error.phone = <Translate textKey={'phone_required'} />;
        validationStatus = false;
      } else {
        const phoneNumber = parsePhoneNumber("+" + phone);
        if (!phoneNumber.isValid()) {
          error.phone = <Translate textKey={'phone_error_msg'} />;
          validationStatus = false;
        }
      }
    } catch (e) {
      error.phone = <Translate textKey={'phone_error_msg'} />;
      validationStatus = false;
    }
    if (projectInfo?.projectConfig?.config?.GOOGLE_CAPTCHA_KEY && !captchaValue) {
      error.captcha = "Captcha Required";
      validationStatus = false;
    }
    setErrors(error)
    return validationStatus;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "country") {
      setValues({
        ...values,
        [name]: value,
      });
    } else if (name === "issues") {
      setValues({
        ...values,
        [name]: value,
      });
      if (value === "Technical Issue") {
        setDisableblock(true);
      } else {
        setDisableblock(false);
      }
    } else {

      setValues({
        ...values,
        [name]: value,
      });
    }
  };

  const handleCaptchaChange = (value) => {
    setCaptchaValue(value);
  };
  const onDialCodeChangeHandler = (phone_number) => {
    setValues({
      ...values,
      phone: phone_number,
      // phone: phone_number.startsWith("+") ? phone_number : `+${phone_number}`,
    });
  }

  const submitHandler = (e) => {
    e.preventDefault();
    const isValid = formValidation();
    if (isValid) {
      setProcessing(true);

      const updatedValues = {
        ...values,
        phone: "+" + values?.phone,
        captchaToken: captchaValue,
      };
      updateContact(updatedValues);
    }
  };


  const updateContact = async (updatedValues) => {
    try {
      const response = await updateContactSuppport(appInfo, updatedValues);
      if (response?.status === 200) {
        setProcessing(false);
        toast.success(<Translate textKey={'thanks_message'} />, {
          position: "bottom-center",
        });
        setValues({
          country: "",
          issues: "",
          fname: "",
          lname: "",
          phone: "",
          email: "",
          movie: "",
          platform: "",
          topic: "",
          message: ""
        });
        setDisableblock(false);
        setCountry([]);
      }
    } catch (err) {
      toast.error(err?.message, {
        position: "bottom-center",
      });
    }
  };
  return (
    <div className="contactSupportWhite">
      <div className="wrapper">
        <h1 className="heading">Kalingo Support</h1>
        <div className="formContainer">
          <form>
            <div className="full">
              <input
                className={errors?.fname ? "error" : ""}
                type="text"
                name="fname"
                placeholder={translateText("first_name")}
                onChange={handleChange}
                value={values?.fname || ""}
              />
              {/* {errors?.fname && <span className="error">{errors?.fname}</span>} */}

            </div>
            <div className="full">
              <input
                className={errors?.lname ? "error" : ""}
                type="text"
                name="lname"
                placeholder={translateText("last_name")}
                onChange={handleChange}
                value={values?.lname || ""}
              />
              {/* {
                errors?.lname &&
                <span className="error">{errors?.lname}</span>
              } */}

            </div>
            <div className="full">
              <PhoneInput
                inputClass={errors?.phone ? "error" : ""}
                enableSearch={true}
                dropdownStyle={{
                  height: '200px',
                  textAlign: 'justify',
                }}
                country={'us'}
                inputStyle={{
                  width: '100%',
                  padding: '0% 2% 0% 12%;',
                  height: '36px',
                }}
                containerClass="phone-input-responsive"
                type="tel"
                name="phone"
                onChange={onDialCodeChangeHandler}
                value={values?.phone || ""}
                id="phone"
              />
              {/* {errors?.phone && <span className="error text-danger">{errors?.phone}</span>} */}
            </div>

            <div className="full">
              <input
                className={errors?.email ? "error" : ""}
                type="email"
                name="email"
                placeholder={translateText("email")}
                onChange={handleChange}
                value={values?.email || ""}

              />
              {/* {
                errors?.email &&
                <span className="error">{errors?.email}</span>
              } */}
            </div>
            <div className="full">
              <select name="country" id="country" className={errors?.country ? "error" : ""} value={values?.country || "US"} onChange={handleChange}>
                <option value=""><Translate textKey={'select_country'} /></option>
                {country?.map((item, index) => {
                  return (
                    <option key={index} value={item.isoCode}>
                      {item.name}
                    </option>
                  );
                })}
              </select>
              {/* {
                errors?.country &&
                <span className="error">{errors?.country}</span>
              } */}
            </div>
            <div className="full">
              <input
                className={errors?.movie ? "error" : ""}
                type="text"
                name="movie"
                placeholder={translateText("contact_movie_placeholder")}
                onChange={handleChange}
                value={values?.movie || ""}

              />
              {/* {
                errors?.movie &&
                <span className="error">{errors?.movie}</span>
              } */}
            </div>
            <div className="full">

              {advertise ? (
                <input type="text" value={translateText("advertise_with_us")} disabled />
              ) : (
                <select
                  name="issues"
                  id="issues"
                  className={errors?.issues ? "error" : ""}
                  onChange={handleChange}
                  value={values?.issues || ""} >
                  <option value="">Reason for contacting us</option>
                  <option value="Technical Issue" ><Translate textKey={'technical_issue'} /></option>
                  <option value="Partner with us"><Translate textKey={'partner_with_us'} /></option>
                  <option value="Advertise with us"><Translate textKey={'advertise_with_us'} /></option>
                  <option value="Submit your Script">Submit your Script</option>
                  <option value="Submit your Content">Submit your Content</option>
                  <option value="Request Film Financing">Request Film Financing</option>
                  <option value="Request Collaboratonion">Request Collaboration</option>
                  <option value="Request to Rent a TV Channel">Request to Rent a TV Channel</option>
                  <option value="Request to Rent TV Airtime">Request to Rent TV Airtime</option>
                  <option value="Request to Stream an Event per PPV">Request to Stream an Event per PPV</option>
                  <option value="Get your Existing TV Channel on Kalingo">Get your Existing TV Channel on Kalingo</option>
                  <option value="Get your content / videos on Kalingo TV">Get your content / videos on Kalingo TV</option>
                  <option value="Advertise With Us">Advertise With Us</option>
                  <option value="Other"><Translate textKey={'other'} /></option>
                </select>

              )}
              {
                console.log(errors?.issues, " errors?.issues")

              }
              {/* {
                errors?.issues &&
                <span className="error">{errors?.issues}</span>
              } */}
            </div>
            {disableblock === true && (
              <>
                <div className="full">
                  <select name="platform" id="platform" onChange={handleChange}>
                    <option><Translate textKey={'select_platform'} /></option>
                    <option value="Website">Website</option>
                    <option value="Roku">Roku</option>
                    <option value="Android">Android</option>
                    <option value="Ios">iOS</option>
                    <option value="Apple TV">Apple TV</option>
                    <option value="Android TV">Android TV</option>
                    <option value="Amazon Fire">Amazon Fire</option>
                  </select>
                  {/* {
                    errors?.platform &&
                    <span className="error">{errors?.platform}</span>
                  } */}
                </div>
                <div className="full">
                  <select name="topic" id="topic" onChange={handleChange}>
                    <option value="Select Topic"><Translate textKey={'select_topic'} /></option>
                    <option value="Account"><Translate textKey={'account'} /></option>
                    <option value="Audio"><Translate textKey={'audio'} /></option>
                    <option value="Content"><Translate textKey={'content'} /></option>
                    <option value="Content Request"><Translate textKey={'content_request'} /></option>
                    <option value="Registration"><Translate textKey={'registration'} /></option>
                    <option value="Sign-In"><Translate textKey={'sign_in'} /></option>
                    <option value="Subtitle"><Translate textKey={'subtitle_caption'} /></option>
                    <option value="Video Playlist"><Translate textKey={'video_playlist'} /></option>
                    <option value="Other"><Translate textKey={'other'} /></option>
                  </select>
                  {/* {
                    errors?.topic &&
                    <span className="error">{errors?.topic}</span>
                  } */}
                </div>
              </>
            )}

            <div className="full message">
              <label htmlFor="message"><Translate textKey={'message'} /></label>
              <textarea
                id="message"
                className={errors?.message ? "error" : ""}
                name="message"
                placeholder={translateText("message")}
                onChange={handleChange}
                value={values?.message || ""}
              ></textarea>
              {/* {
                errors?.message &&
                <span className="error">{errors?.message}</span>
              } */}
            </div>
            {projectInfo?.projectConfig?.config?.GOOGLE_CAPTCHA_KEY && (
              <div className="full">
                <div className="buttonContainer captcha-container">
                  <ReCAPTCHA
                    ref={captchaRef}
                    sitekey={projectInfo?.projectConfig?.config?.GOOGLE_CAPTCHA_KEY}
                    onChange={handleCaptchaChange}
                  />
                  {/* {errors?.captcha && (
                        <span className="error">{errors?.captcha}</span>
                      )} */}
                </div>
              </div>
            )}
            <div className="full submit-button">
              <div className="buttonContainer submit-container">
                <button type="submit" disabled={processing} onClick={submitHandler}> {processing ? 'Sending...' : <Translate textKey={'submit'} />} </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactSupportKalingo;
